/**
 * Event PubSub Module
 */
define('atn/atnEvents',['jquery', 'lodash', './config'],
	function($, _, config) {
		'use strict';
		var atnPostMessageQueue = [];
		var atnEventsList = [];
		return {
			subscribeEvent: subscribeEvent,
			registerEvent: registerEvent
		};

		/**
		 * [registerEvent - for adding event to window object]
		 * @param  {String} eventName name of the event
		 * @return {undefined}
		 */
		function registerEvent(eventName) {
			if (_.indexOf(atnEventsList,eventName) == -1) {
				window.addEventListener(eventName, recieveMessage, false);
			}
		}

		/**
		 * [subscribeEvent - to add event callback to queue]
		 * @param  {String} eventName [event name]
		 * @param {object} eventDetails [which contains event details like: 
		 * {
                'evtCallbackFn': recieveMessage,
                'evtTarget':'splash_page'
            }]
		 */
		function subscribeEvent(eventName, eventDetails) {
			atnPostMessageQueue.push(eventDetails);
		}

		/**
		 * [recieveMessage - event handler for postMessage Api]
		 * @param  {Event object} event
		 * @return {undefined}
		 */
		function recieveMessage(evt) {
			//matching the origin of the postMessage recieved message on 'save and exit' with the brandBuilderUrl domain for securing postmessage.
			if (evt.origin.match(config.brandBuilderRegex)) 
			{
				var recdJsonData = JSON.parse(evt.data);
				var target = recdJsonData.target;
				var entityName = recdJsonData.params.name;
				_.forEach(atnPostMessageQueue, function(element) {
					if (element.evtTarget === target && _.isFunction(element.evtCallbackFn)) {
						element.evtCallbackFn(entityName);
					}
				});
			}
		}
	});
